import { Injectable } from '@angular/core';
import { KeycloakEvent, KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { InformacaoSistemaService } from 'src/app/shared/shared-services/informacaoSistema.service';
import { AuthHelper } from 'src/app/shared/shared-utils/auth-helper';
import { interval } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthKeycloakService {
    constructor(
        private keycloak: KeycloakService,
        private authHelper: AuthHelper,
        private informacaoSistemaService: InformacaoSistemaService
    ) {
        // Start storing token in localStorage periodically
        this.startTokenStorageInterval();

        this.keycloak.keycloakEvents$.subscribe(async (event: KeycloakEvent) => {
            switch (event.type) {
                case (KeycloakEventType.OnAuthSuccess): {
                    this.informacaoSistemaService.configurarInformacoesSistema(await this.keycloak.loadUserProfile());
                    // Store token in localStorage after successful authentication
                    this.storeTokenInLocalStorage();
                    break;
                }
                case (KeycloakEventType.OnTokenExpired): {
                    if (this.keycloak.getKeycloakInstance().refreshToken) {
                        this.keycloak.updateToken();
                        // Store updated token in localStorage
                        this.storeTokenInLocalStorage();
                    } else {
                        this.authHelper.logout();
                    }
                    break;
                }
                case (KeycloakEventType.OnAuthError): {
                    this.authHelper.logout();
                    break;
                }
                case (KeycloakEventType.OnAuthRefreshError): {
                    this.authHelper.logout();
                    break;
                }
            }
        });
    }

    /**
     * Stores the Keycloak token in localStorage for backward compatibility
     */
    private storeTokenInLocalStorage(): void {
        if (this.keycloak.getKeycloakInstance() && this.keycloak.getKeycloakInstance().token) {
            localStorage.setItem('KeycloackToken', this.keycloak.getKeycloakInstance().token);
        }
    }

    /**
     * Starts an interval to periodically store the token in localStorage
     * This ensures the token is always up-to-date in localStorage
     */
    private startTokenStorageInterval(): void {
        // Store token immediately if available
        this.storeTokenInLocalStorage();

        // Store token every 30 seconds
        interval(30000)
            .pipe(
                // Stop the interval when the component is destroyed
                takeWhile(() => true)
            )
            .subscribe(() => {
                this.storeTokenInLocalStorage();
            });
    }
}
